module.exports = __webpack_public_path__ + "img/sodelco-logo-1x.3db9d11d.png";